function discountToTruncatedCents(value: number | string | null | undefined): number | null {
  const n = typeof value === 'string' ? parseFloat(value) : Number(value);
  if (!Number.isFinite(n) || n <= 0) {
    return null;
  }
  return Math.floor(n * 100 + 1e-6);
}

/** Truncated discount % as a number (max 2 decimal places, no rounding). */
export function truncateDiscountPercent(value: number | string | null | undefined): number {
  const cents = discountToTruncatedCents(value);
  if (cents == null) {
    return 0;
  }
  return cents / 100;
}

/**
 * Truncates a positive discount % to 2 decimal places (no rounding) and formats for UI.
 * Examples: 12.349 → "12.34", 15 → "15", 10.5 → "10.5"
 */
export function formatDiscountPercentage(value: number | string | null | undefined): string {
  const cents = discountToTruncatedCents(value);
  if (cents == null) {
    return '0';
  }
  const intPart = Math.floor(cents / 100);
  const frac = cents % 100;
  if (frac === 0) {
    return String(intPart);
  }
  if (frac % 10 === 0) {
    return `${intPart}.${frac / 10}`;
  }
  return `${intPart}.${frac.toString().padStart(2, '0')}`;
}
